import { useEffect, useState } from "react";

export function useExperiment(experimentId: string) {
  const [variant, setVariant] = useState();
  useEffect(() => {
    (async () => {
      const intervalId = setInterval(() => {
        if (window.google_optimize !== undefined) {
          setVariant(window.google_optimize.get(experimentId));
          clearInterval(intervalId);
        }
      }, 100);
    })();
  });
  return variant;
}
